import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Loader2 } from 'lucide-react'
import { cn } from '@/utils/cn'

export type AppButtonVariant = 'primary' | 'outline' | 'ghost'

export type AppButtonProps = {
  children: ReactNode
  onClick?: () => void
  disabled?: boolean
  loading?: boolean
  variant?: AppButtonVariant
  block?: boolean
  type?: 'button' | 'submit' | 'reset'
  className?: string
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'onClick' | 'disabled' | 'children'>

const VARIANT_CLASS: Record<AppButtonVariant, string> = {
  primary: 'rfid-btn--primary',
  outline: 'rfid-btn--outline',
  ghost: 'rfid-btn--ghost',
}

export function AppButton({
  children,
  onClick,
  disabled,
  loading,
  variant = 'primary',
  block,
  type = 'button',
  className,
  ...rest
}: AppButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={cn('rfid-btn', VARIANT_CLASS[variant], block && 'rfid-btn--block', className)}
      {...rest}
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" strokeWidth={2.5} /> : null}
      {children}
    </button>
  )
}
